module.exports = __webpack_public_path__ + "static/media/nh2.3feeb758.png";